import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportComponent } from './components/report/report.component';
import { RouterModule } from '@angular/router';
import { REPORT_ROUTES } from './reports.routes';
import { ReportResolver } from './resolvers/report.resolver';
import { FlowInstanceService } from '../flow/services/flow-instance.service';
import { LunaCommonModule } from '../common/common.module';
import { LoginAuthComponent } from './login-auth/login-auth.component';
import { ReportsService} from "./reports.service";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgGridModule } from 'ag-grid-angular'; 


@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        LunaCommonModule,
        ReactiveFormsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        AgGridModule,
        RouterModule.forChild(REPORT_ROUTES),
    ],
    declarations: [ReportComponent, LoginAuthComponent],
    providers: [ReportResolver, FlowInstanceService, ReportsService]
})
export class ReportsModule { }

